import i18n from "../../plugins/I18nPlugin";

export function numberLowerRule(
  lowerValue: number,
  message = "components.thg.ThgQuoteUpdateDialog.ruleLower"
): (value: any) => boolean | string {
  return value => value <= lowerValue || String(i18n.tc(message)) + " " + lowerValue;
}
